export const ATTENDANCE_TIME_ERROR =
  'No attendance found on the selected date to resume duty, kindly select some other date!';
